import React, { useState } from 'react';
import { MdArrowBack, MdCheckCircleOutline, MdNotificationsNone } from 'react-icons/md';

const CallVerificationScreen = ({ onNavigate, onBack }) => {
  const [isLegitCall, setIsLegitCall] = useState(true);

  return (
    <div className="screen security-check-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Security Check</h1>
        </div>
      </header>

      <div className="scroll-content gray-bg">
        <div className="security-status-hero">
          <div className={`status-icon-ring ${isLegitCall ? 'safe-ring' : 'scam-ring'}`}>
            {isLegitCall ? <MdCheckCircleOutline size={60} /> : <MdNotificationsNone size={60} />}
          </div>

          <h1 className="status-main-text">
            {isLegitCall ? "You're speaking with TD" : "Highly Suspicious Call"}
          </h1>
          <p className="status-sub-text">
            {isLegitCall
              ? "We've verified that a TD representative is currently on a call with you."
              : "We are NOT currently calling you. This caller may be impersonating the bank."}
          </p>
        </div>

        <div className="white-container status-details-card">
          <div className={`status-badge ${isLegitCall ? 'bg-safe' : 'bg-scam'}`}>
            {isLegitCall ? "VERIFIED CALL" : "SECURITY WARNING"}
          </div>

          <div className="status-info-row">
            <span>Call Status:</span>
            <strong className={isLegitCall ? 'positive-green' : 'text-danger'}>
              {isLegitCall ? 'Active & Secure' : 'No Active TD Call'}
            </strong>
          </div>
          <div className="status-info-row">
            <span>Time of Check:</span>
            <strong>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</strong>
          </div>
        </div>

        {!isLegitCall && (
          <div className="scam-action-box">
            <h3>Protect yourself:</h3>
            <ul>
              <li>Hang up immediately.</li>
              <li>Do not share one-time passcodes or PINs.</li>
              <li>TD will never ask for your full password over the phone.</li>
            </ul>
            <button className="report-scam-btn">REPORT THIS NUMBER</button>
          </div>
        )}

        <div className="demo-toggle-container">
          <p>Demo: Toggle call state</p>
          <button onClick={() => setIsLegitCall(!isLegitCall)}>
            Switch to {isLegitCall ? 'Scam Warning' : 'Safe Call'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallVerificationScreen;
